import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { formatNumberWithSuffix } from '@utils/helper';

const MyChart = ({
	yearWithColor,
	chartData,
	maxBarsVisible = 8,
	barWidth = 100,
	isCompareEnable,
	barList,
	numberOfBars
}) => {
	const chartWidth = chartData?.length > maxBarsVisible ? chartData?.length * barWidth : '100%';
	const radius = 7;

	const formatYAxis = (tick) => {
		return formatNumberWithSuffix(tick);
	};

	const customLabelFormatter = (label) => {
		return `${label}`; // Example: "Q1, 2024"
	};
	const customFormatter = (value, name) => {
		if (name === 'target' && value > 0) {
			return [`${formatNumberWithSuffix(value)}`, 'Target']; // Simplify target value (convert to millions)
		} else if (name === 'unachieved' && value > 0) {
			return [`${formatNumberWithSuffix(value)}`, 'Unachieved Previous Target']; // Simplify target value (convert to millions)
		} else if (name === 'achieved' && value > 0) {
			return [`${formatNumberWithSuffix(value)}`, 'Achieved']; // Simplify target value (convert to millions)
		} else if (name === 'pipeline' && value > 0) {
			return [`${formatNumberWithSuffix(value)}`, 'Pipeline']; // Simplify target value (convert to millions)
		} else if (typeof name === 'number') {
			return [`${formatNumberWithSuffix(value)}`, name];
		} else {
			return [''];
		}
	};

	return (
		<div className="scroll-x-label" style={{ height: 200 }}>
			<ResponsiveContainer width={chartWidth}>
				<BarChart
					width={100}
					height={500}
					data={chartData}
					margin={{ bottom: chartData?.length > numberOfBars ? 40 : 5 }}
					style={{
						fontSize: '0.8rem',
						fontWeight: 'normal',
						fontFamily: 'Inter'
					}}
					barCategoryGap={50}
				>
					<CartesianGrid stroke="#f5f5f5" />
					<XAxis
						dataKey="name"
						angle={chartData?.length > numberOfBars && -15}
						textAnchor="end"
						interval={0}
					/>
					<YAxis tickFormatter={formatYAxis} />

					<Tooltip
						cursor={{ fill: 'transparent' }}
						labelFormatter={customLabelFormatter}
						formatter={customFormatter}
					/>

					{isCompareEnable && yearWithColor && yearWithColor.length > 0 && yearWithColor[0].fill ? (
						yearWithColor.map((item, index) => (
							<Bar
								barSize={15}
								key={index}
								dataKey={item.year}
								fill={item.fill}
								radius={[radius, radius, 0, 0]}
							/>
						))
					) : (
						<>
							{barList.map((bar, idx) => (
								<Bar
									key={`bar_${idx}`}
									barSize={15}
									dataKey={bar.dataKey}
									fill={bar.fill}
									radius={[radius, radius, 0, 0]}
								/>
							))}
						</>
					)}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};
export default MyChart;
